import { useEffect, useRef } from "react";

interface UsePollOptions {
  intervalMs: number;
  enabled: boolean;
}

/**
 * Invokes `callback` every `intervalMs` milliseconds while `enabled` is true.
 * The callback is kept in a ref so callers can pass an inline closure without
 * resetting the interval on every render.
 */
export function usePoll(
  callback: () => void,
  { intervalMs, enabled }: UsePollOptions,
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const intervalId = setInterval(() => callbackRef.current(), intervalMs);
    return () => clearInterval(intervalId);
  }, [intervalMs, enabled]);
}
